export enum OrderBy {
    NAME = 'name',
    NEWEST = 'newest',
    OLDEST = 'oldest',
}